<template>
  <CaseStudy
    title="YZY"
    :logo="require('@/assets/logos/yzy.png')"
    :thumbnail="require('@/assets/screenshots/yzy.png')"
    iframeLink="https://iframe.bubblemaps.io/map/KjWyQPtwRI4r1qr5w9bI?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1958604074640695424"
    isOdd
    :featuredIn="[
      {
        name: 'TheBlock',
        logo: require('@/assets/logos/medias/theblock.png'),
        link: 'https://www.theblock.co/post/368557/kanye-west-yzy-11-netted-millions',
        color: '#EBFE7C',
      },
      {
        name: 'Decrypt',
        logo: require('@/assets/logos/medias/decrypt.png'),
        link: 'https://decrypt.co/336762/libra-wallets-linked-hayden-davis-made-12-million-kanye-west-meme-coin',
      },
      {
        name: 'CoinDesk',
        logo: require('@/assets/logos/medias/coindesk.png'),
        link: 'https://www.coindesk.com/markets/2025/08/28/yzy-hype-machine-leaves-traders-nursing-millions-in-losses-on-ye-linked-token',
        color: '#F8BF1E',
      },
    ]"
  >
    How Kanye West’s meme coin turned into a <b>chaotic dumpfest</b>, with
    insiders cashing out millions
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
